<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="chevron"
  >
    <path
      d="M6 9L12 15L18 9"
      :stroke="colors[color]"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "blue"
    }
  },
  data: function() {
    return {
      colors: {
        blue: "#3876D2",
        white: "#fff"
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/Chevron.vue